import React, { useState, Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import ResultModal from '../../Components/Modal/ResultModal.component';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import EditUserSubmit from './Buttons/UserEditSubmit.component';
import ActivateUserButton from './Buttons/UserEditActivate.component';
import DeleteUserButton from './Buttons/UserEditDelete.component';
import DisableUserButton from './Buttons/UserEditDisable.component';
import ManagerEmployeeInput from '../../Components/UserForm/ManagerEmployeeInputs.component';
import ResentLoginEmail from './ResendLoginEmail/ResendLogin.component';
import {
  CompanyDataDiv,
  SectionBox,
} from '../../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHome.styles';
import AssignUserToCompany from './AdminOnlyElements/UserToCompany.component';
import AlreadyPurchasedCourses from './AdminOnlyElements/AlreadyPurchasedCourse.component';
import NotPurchasedCourses from './AdminOnlyElements/NotPurchasedCourse.component';

const UserEdit = ({ user, userData, courses }) => {
  const [successState, setSuccessState] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [userEdited, setUserEdited] = useState([]);
  const [type, setType] = useState();
  useEffect(() => {
    if (user) {
      setUserEdited(user);
      setType(user?.type);
    }
  }, [user]);
  const filterNotPurchasedCourses = (user, courses) => {
    if (user && Array.isArray(courses)) {
      const userCourseIds =
        user?.courses?.map((course) => course?.courseId) || [];
      // Return courses that are NOT in user's course list
      return courses.filter((course) => !userCourseIds.includes(course._id));
    }
    return [];
  };

  const notPurchasedCourses = filterNotPurchasedCourses(user, courses);
  return (
    <>
      <CompanyDataDiv>
        <SectionBox>
          <ManagerEmployeeInput
            user={userEdited}
            setUser={setUserEdited}
            type={type}
            setType={setType}
            showType={true}
          />
        </SectionBox>
      </CompanyDataDiv>
      {/* <Suspense fallback={<p>Loading user details...</p>}>
        <UserDetailSection user={user} />
      </Suspense> */}
      <SubmitContainer>
        <TopSubmit>
          {successState.length > 0 && <p className="result">{successState}</p>}
        </TopSubmit>
        <BottomSubmit>
          <Suspense fallback={<p>Loading delete button...</p>}>
            <DeleteUserButton
              id={user._id}
              setSuccessState={setSuccessState}
              setIsOpen={setIsOpen}
            />
          </Suspense>
          <Suspense fallback={<p>Loading activation/deactivation button...</p>}>
            {user?.active ? (
              <DisableUserButton
                id={user._id}
                setSuccessState={setSuccessState}
                setIsOpen={setIsOpen}
              />
            ) : (
              <ActivateUserButton
                id={user._id}
                setSuccessState={setSuccessState}
                setIsOpen={setIsOpen}
              />
            )}
          </Suspense>
          <Suspense fallback={<p>Loading submit button...</p>}>
            <EditUserSubmit
              user={userEdited}
              type={type}
              successState={successState}
              setSuccessState={setSuccessState}
              setIsOpen={setIsOpen}
            />
          </Suspense>
        </BottomSubmit>
      </SubmitContainer>
      <ResultModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        result={successState}
        linkTo="/admin"
      />
      <ResentLoginEmail user={user} />
      {/* Only Admin */}
      {userData?.type === 'Admin' && (
        <>
          <AssignUserToCompany
            userId={user._id}
            userCompany={user?.company?.[0]?.companyId?.companyName}
          />
          <AlreadyPurchasedCourses
            // courses={user?.courses}
            userId={user._id}
            email={user?.email}
            userName={`${user.firstName} ${user.lastName}`}
            courses={courses}
          />
          <NotPurchasedCourses
            notPurchasedCourses={notPurchasedCourses}
            userId={user._id}
            email={user.email}
            userName={`${user.firstName} ${user.lastName}`}
            courses={courses}
          />
        </>
      )}
    </>
  );
};
UserEdit.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
    active: PropTypes.bool,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    courses: PropTypes.array,
    company: PropTypes.array,
  }),
  userData: PropTypes.object,
  courses: PropTypes.object,
};

export default UserEdit;
